import { Link } from "react-router-dom";
import CompanyListTable, {
  formatCreated,
} from "../../components/AdminDashboard/CompanyListTable";

const COLUMNS = [
  {
    header: "Company Name",
    render: (row) => (
      <Link
        to={`/admin-dashboard/sellers/${row?._id}`}
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        {row?.name}
      </Link>
    ),
  },
  { header: "Name", render: (row) => row?.ceoName },
  { header: "Industry", render: (row) => row?.industry },
  { header: "Created", preWrap: true, render: (row) => formatCreated(row?.createdAt) },
  { header: "Location", render: (row) => row?.address },
];

const Seller = () => (
  <CompanyListTable
    type="Seller"
    title="Seller"
    emptyLabel="sellers"
    columns={COLUMNS}
  />
);

export default Seller;
